import type { LucideIcon } from "lucide-react";
import {
  BarChart3,
  Bot,
  CalendarRange,
  Calculator,
  Footprints,
  Home,
  Info,
  Medal,
  Table2,
  Timer,
  Upload,
  UserRound,
} from "lucide-react";

export type NavItem = {
  to: string;
  label: string;
  short?: string;
  icon: LucideIcon;
  /** Also shown when logged out. */
  public?: boolean;
  /**
   * Kept out of every menu (sidebar, drawer, bottom-bar "More") but left in
   * the list, so re-showing it is one flag. The route and its page title stay
   * — the page is still reachable by URL.
   */
  hidden?: boolean;
};

export const primaryNav: NavItem[] = [
  { to: "/home", label: "Home", icon: Home },
  { to: "/runs", label: "Activities", icon: Footprints },
  { to: "/pb", label: "Personal Bests", short: "PBs", icon: Medal },
  { to: "/pbtable", label: "PB Table", icon: Table2 },
  { to: "/stats", label: "Stats", icon: BarChart3 },
  { to: "/annual", label: "Annual", icon: CalendarRange },
  { to: "/pacecalc", label: "Pace Calculator", short: "Pace Calc", icon: Calculator, public: true },
];

const SECONDARY: NavItem[] = [
  { to: "/upload", label: "Upload", icon: Upload },
  { to: "/connected-ai", label: "Connected AI", icon: Bot },
  // #444: not advertised until the Run Clock launches. /devices still works.
  { to: "/devices", label: "Run Clock", icon: Timer, hidden: true },
  { to: "/account", label: "Account", icon: UserRound },
  { to: "/about", label: "About", icon: Info, public: true },
];

/** The secondary menu as rendered; every renderer spreads this, so `hidden` is honoured once, here. */
export const secondaryNav: NavItem[] = SECONDARY.filter((i) => !i.hidden);

/** Route → page title for the top bar. Longest prefix wins. */
const titles: [string, string][] = [
  ["/home", "Home"],
  ["/runs/", "Activity"],
  ["/runs", "Activities"],
  ["/viewactivity", "Activity"],
  ["/pbtable", "PB Table"],
  ["/pb", "Personal Bests"],
  ["/stats", "Stats"],
  ["/annual", "Annual Summaries"],
  ["/pacecalc", "Pace Calculator"],
  ["/upload", "Upload"],
  ["/connected-ai", "Connected AI"],
  ["/devices/setup", "Set up a Run Clock"],
  ["/devices", "Run Clock"],
  ["/account", "Account"],
  ["/about", "About"],
  ["/privacy", "Privacy"],
  ["/terms", "Terms"],
  ["/impersonate", "Impersonate"],
  ["/onboarding", "Get started"],
  ["/connect", "Connect Garmin"],
  ["/oauth/consent", "Connect an app"],
];

export function pageTitleFor(pathname: string): string {
  let best = "";
  let title = "PB-Ranks";
  for (const [prefix, t] of titles) {
    if (pathname.startsWith(prefix) && prefix.length > best.length) {
      best = prefix;
      title = t;
    }
  }
  return title;
}
